var map = {
	"./background.svg": "7fc9",
	"./close.svg": "c145",
	"./crop.svg": "514d",
	"./decorate.svg": "423d",
	"./flip.svg": "25f7",
	"./focus.svg": "1cb3",
	"./logo.svg": "93ff",
	"./redo.svg": "16e8",
	"./revert.svg": "8a38",
	"./rotate_left.svg": "7341",
	"./text.svg": "d75b",
	"./transparent.svg": "7ffa",
	"./undo.svg": "5532"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5e33";